import {Button, message} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {t} from "i18next";
import React from "react";

const CreateGetirPicture = ({
    photoUrl,
    courierTckn,
    courierId,
    buttonText,
    onCompleted,
    disabled = false,
    getirImageUrl = null
}) => {
    const stores = useStore();
    const [hasGetirImage, setHasGetirImage] = React.useState(!!getirImageUrl);

    React.useEffect(() => {
        setHasGetirImage(!!getirImageUrl);
    }, [getirImageUrl]);

    const [loading, data, setData, setLoading, refetch] = useFetch({
        defaultDataValue: null,
        fetchFn: () =>
            stores.courierStore.createGetirImageWebhook({
                tckn: courierTckn,
                courierId: courierId,
                photoUrl
            }),
        dependencies: [courierTckn, photoUrl],
        initialCall: false,
        callbackFunc: async response => {
            if (response) {
                if (response.getirImageUrl) {
                    window.location.reload();
                } else {
                    message.error(response?.message || "Getir görseli oluşturulamadı");
                }
            } else {
                message.error("Getir görseli oluşturulamadı");
            }
            return response;
        }
    });

    const handleGenerate = () => {
        refetch();
    };

    return (
        <Button
            shape="round"
            size="middle"
            type="primary"
            loading={loading}
            onClick={handleGenerate}
            disabled={disabled}
        >
            {buttonText || t("actions.createGetirPicture", {ns: "courierDetail"})}
        </Button>
    );
};

export default CreateGetirPicture;
